/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TileRateApartment_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    name?: string;
    roomType?: TileRateApartment_jsonld.roomType;
    size?: number;
    singleBeds?: number;
    doubleBeds?: number;
};
export namespace TileRateApartment_jsonld {
    export enum roomType {
        ROOM = 'room',
        SUITE = 'suite',
        APARTMENT = 'apartment',
        COMPLETE = 'complete',
    }
}
